import React from 'react';
import { patterns } from '../../data/patterns';
import { clsx } from 'clsx';

const PatternSelector = ({ currentPatternId, onSelect }) => {
  return (
    <div className="grid grid-cols-2 gap-3">
      {patterns.map((pattern) => {
        const PatternComponent = pattern.component;
        const isSelected = currentPatternId === pattern.id;
        
        return (
          <button
            key={pattern.id}
            onClick={() => onSelect(pattern.id)}
            className={clsx(
              "relative flex flex-col items-center p-3 rounded-xl border-2 transition-all group",
              isSelected 
                ? "border-emerald-600 bg-emerald-50/50 ring-1 ring-emerald-600" 
                : "border-slate-200 hover:border-slate-300 bg-white hover:shadow-md"
            )}
          >
            <div className="w-16 h-16 mb-2 overflow-hidden rounded shadow-sm">
              <PatternComponent 
                colors={pattern.defaultColors} 
                className="w-full h-full"
              />
            </div>
            <span className={clsx(
              "text-xs font-medium text-center",
              isSelected ? "text-emerald-700" : "text-slate-600"
            )}>
              {pattern.name}
            </span>
            
            {isSelected && (
              <div className="absolute top-2 right-2 w-2 h-2 bg-emerald-600 rounded-full" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default PatternSelector;